import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_URL}/api/road`;

export const uploadFileApi = async (formData) => {
  const response = await axios.post(`${API_BASE_URL}/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response;
};

export const listUploadHistoryApi = async (companyID) => {
  const response = await axios.get(`${API_BASE_URL}/upload-history/${companyID}`);
  return response;
};

export const getUploadProgressMultipleApi = async (uploadHistoryIds) => {
  const response = await axios.post(`${API_BASE_URL}/upload-progress-multiple`, {
    uploadHistoryIDs: uploadHistoryIds,
  });
  return response;
};
